import React from "react";
import "./IntroComponent.css";

function IntroComponent() {
  return (
    <div className="introContainer">
      <div className="centerintro">
        <div className="leftintro">
          <strong>Our Kaarya (Our Work)</strong>
        </div>
        <div className="rightintro">
          At Revamp Hive Studio, we design spaces with intention—a places where
          form and function come together naturally to support the way people
          live, work, and connect. <br /> <br /> We provide full architectural
          consultancy services, guiding every step of the journey with
          thoughtful design, clear communication, and dedicated project
          management to bring each project to life with care.
        </div>
      </div>
    </div>
  );
}

export default IntroComponent;
